import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const TOKEN_DETAILS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'tokenDetails',
    args: [{ name: 'token_id', type: 'String', required: true }],
    argsMap: [{ name: 'token_id', value: 'token_id' }],
    fields: `{
      id
      opportunity_id
      project_id
      buyer_aws_id
      display_token
      status
      amount_minor
      currency_code
      payments {
        token_id
        amount_minor
        currency_code
        method
        reference_number
        online_pay_id
        status
        created_at
        paid_at
        updated_at
      }
      created_at
      expiry_at
      updated_at
    }`,
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const FETCH_LIST_TOKENS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'fetchListTokens',
    operationName: 'fetchListTokens',
    args: [
      { name: 'opportunity_ids', type: '[String]' },
      { name: 'project_id', type: 'String' },
      { name: 'status', type: 'String' },
      { name: 'page', type: 'Int' },
      { name: 'limit', type: 'Int' },
    ],
    argsMap: [
      { name: 'opportunity_ids', value: 'opportunity_ids' },
      { name: 'project_id', value: 'project_id' },
      { name: 'status', value: 'status' },
      { name: 'page', value: 'page' },
      { name: 'limit', value: 'limit' },
    ],
    fields: '{...FetchListTokensResponseFields}',
    fragments: [Fragments.fetchListTokensResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const FETCH_TOKEN_DETAILS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'fetchTokenDetails',
    operationName: 'fetchTokenDetails',
    args: [
      { name: 'token_id', type: 'String' },
      { name: 'opportunity_id', type: 'String' },
    ],
    argsMap: [
      { name: 'token_id', value: 'token_id' },
      { name: 'opportunity_id', value: 'opportunity_id' },
    ],
    fields: '{...FetchTokenDetailsResponseFields}',
    fragments: [Fragments.fetchTokenDetailsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LIST_TOKEN_PAYMENTS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listTokenPayments',
    operationName: 'listTokenPayments',
    args: [
      { name: 'token_id', type: 'String', required: true },
      { name: 'offset', type: 'Int' },
      { name: 'limit', type: 'Int' },
    ],
    argsMap: [
      { name: 'token_id', value: 'token_id' },
      { name: 'offset', value: 'offset' },
      { name: 'limit', value: 'limit' },
    ],
    fields: '{...ListTokenPaymentsResponseFields}',
    fragments: [Fragments.listTokenPaymentsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
